export function canDecodeURIComponent(input: string): boolean {
  try {
    decodeURIComponent(input);
    return true;
  } catch {
    return false;
  }
}
